import { extendTheme } from '@hausgold/designsystem';

// eslint-disable-next-line import/prefer-default-export
const theme = extendTheme({
  /* --- BOOTSTRAP FIXES START --- */
  styles: {
    /**
     * This is usually provided by the `resetCSS` option of the DesignsystemProvider,
     * but it's turned off because of Bootstrap.
     *
     * This does:
     *
     *  * Universal border-box
     *  * Transparent, outline-less buttons by default
     *  * `body` font size of `lg` (16px) instead of the original `md` (14px)
     *
     * Remove this when Bootstrap is removed.
     */
    global: {
      '*,*::before,*::after': {
        boxSizing: 'border-box',
        borderWidth: 0,
        borderStyle: 'solid',
      },
      body: {
        /*
         * We set that font size differently because Bootstrap will freak
         * Out otherwise. This can lead to minor deviations in certain
         * cases, but is okay-ish for a transition phase.
         */
        fontSize: 'lg',
      },
      button: {
        bg: 'transparent',
        appearance: 'none',
        '&:focus': {
          outline: 'none',
        },
      },

      /*
       * This fixes Bootstrap default-styling of `ul`s interacting with the
       * `Wrap` component.
       */
      '.chakra-wrap__list': {
        padding: 0,
        margin: 0,
        marginBottom: 0,
      },
    },
  },
  components: {
    Text: {
      sizes: {
        md: {
          /*
           * Because of Bootstrap's `16px` body font size, the default size of `md` is
           * Not `14px` like in the design system, but `16px`. This is a "fix"
           * for that.
           *
           * We don't use `md` because it would use rem. We'd therefore lose the
           * relative resizing that we rely upon in certain places.
           */
          fontSize: `0.875em`, // = md
        },
      },
    },
  },
  colors: {
    // Heyemi purple colors. Base color is 400, the rest is free-hand.
    purple: {
      25: 'rgb(230,180,255)',
      50: 'rgb(148,29,239)',
      100: 'rgb(105,0,184)',
      200: 'rgb(95,0,166)',
      300: 'rgb(85,0,147)',
      400: 'rgb(75, 0, 130)',
      500: 'rgb(60,0,103)',
    },
    /*
     * Heyemi orange colors. Base color is 400, the rest is free-hand.
     *  HEADS UP: The shade scale logic for this color in MP is against the logic of the colors of the Designsystem. Designsystem: higher number === darker, MP: higher number === brighter.
     */
    orange: {
      100: 'rgb(151,96,0)',
      200: 'rgb(175,126,0)',
      300: 'rgb(202,134,0)',
      400: 'rgb(255, 165, 0)',
      500: 'rgb(250,181,55)',
      600: '#FFC766',
    },
    red: {
      100: '#ffc3c4',
    },
  },
  breakpoints: {
    '2xl': '90rem',
  },
  /* --- BOOTSTRAP FIXES END --- */
});

export default theme;
